export const topHeight = '90'; //定义导航的高度

export const viewVersion = '2026-05-13 10:50';

export const version = Number(viewVersion.replace(/\-| |:/g, ''));


// WEBPACK FOOTER //
// ./src/index.js